import { NgModule } from '@angular/core';
import {
  CurrencyPipe,
  DatePipe,
  KeyValuePipe,
  PercentPipe,
} from '@angular/common';
import { BaseModule } from '@shared';
import { SharedDataModule } from '@shared-data';
import {
  AlertsBannerComponent,
  PricingComponent,
  AvailabilityComponent,
  CustomFilterComponent,
  SchedulerComponent,
  PendingChangesGridComponent,
  AvailabilityComboChangesetComponent,
  UpchargeChangesetComponent,
  ComboChangesetComponent,
  OverrideGridComponent,
  SyncButtonComponent,
  SubstitutionChangesetComponent,
  LtoChangesetComponent,
  KidMealChangesetComponent,
  ComboMarkupInfoComponent,
  ComboDiscountInfoComponent,
} from './components';
import { RestaurantItemComponent } from './restaurant-item.component';
import { RestaurantItemRoutingModule } from './restaurant-item-routing.module';
import { RestaurantItemService } from './services';
import { FilterChangesetTypePipe } from './pipes';
import { BaseAvailabilityChangesetComponent } from './components/base-availability-changeset/base-availability-changeset.component';
import { BasePricingChangesetComponent } from './components/base-pricing-changeset/base-pricing-changeset.component';
@NgModule({
  declarations: [
    ComboChangesetComponent,
    AlertsBannerComponent,
    SchedulerComponent,
    PricingComponent,
    CustomFilterComponent,
    AvailabilityComponent,
    RestaurantItemComponent,
    SyncButtonComponent,
    PendingChangesGridComponent,
    FilterChangesetTypePipe,
    AvailabilityComboChangesetComponent,
    UpchargeChangesetComponent,
    OverrideGridComponent,
    SubstitutionChangesetComponent,
    LtoChangesetComponent,
    BaseAvailabilityChangesetComponent,
    BasePricingChangesetComponent,
    KidMealChangesetComponent,
    ComboMarkupInfoComponent,
    ComboDiscountInfoComponent,
  ],
  imports: [BaseModule, RestaurantItemRoutingModule, SharedDataModule],
  exports: [
    RestaurantItemComponent,
    AlertsBannerComponent,
    SyncButtonComponent,
  ],
  providers: [
    PercentPipe,
    DatePipe,
    CurrencyPipe,
    KeyValuePipe,
    RestaurantItemService,
  ],
})
export class RestaurantItemModule {}
